import { Component } from '@angular/core';

@Component({
  selector: 'app-danke',
  standalone: true,
  imports: [],
  templateUrl: './danke.component.html',
  styleUrl: './danke.component.scss'
})
export class DankeComponent {

}
